import { CircularProgress } from "@mui/material";
import { CustomScheduleModalFormType } from "../../../../../types";

interface CustomScheduleFormFooterProps {
    formType: CustomScheduleModalFormType;
    disabledCancel: boolean;
    disabled: boolean;
    onFormSubmit: () => void;
    secondaryButtonText: string;
    primaryButtonText: string;
    loading: boolean;
    onCancel: () => void;
}

const CustomScheduleFormFooter = ({ formType, disabledCancel, disabled, onFormSubmit, secondaryButtonText, primaryButtonText, loading, onCancel }: CustomScheduleFormFooterProps) => {

    return (
        <div className='custom__schedule__modal__form__footer'>
            {formType !== 'schedule' &&
                <button className='custom__schedule__modal__form__footer__button button__outline'
                    disabled={disabledCancel}
                    onClick={onCancel}
                >
                    {secondaryButtonText}
                </button>
            }
            <button
                className={`custom__schedule__modal__form__footer__button button__primary ${'schedule' === formType && 'large'}`}
                disabled={disabled} onClick={onFormSubmit}
            >
                {primaryButtonText} {loading && <CircularProgress size={16} color="inherit" />}
            </button>
        </div>
    )
}

export default CustomScheduleFormFooter